import React, { ReactElement } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import styles from './ConfirmationModal.module.scss';

interface ConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
  loading?: boolean;
  disabled?: boolean;
  onCancelText: string;
  onOkText: string;
  title: string;
  message: string | ReactElement;
  isDanger?: boolean;
}

const ConfirmationModal = ({
  open,
  onCancel,
  onOk,
  loading,
  disabled,
  title,
  message,
  onCancelText,
  onOkText,
  isDanger = true,
}: ConfirmationModalProps) => {
  const getModalContent = () => {
    return (
      <div>
        <h5>{title}</h5>
        <div>{message}</div>
      </div>
    );
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      cancelText={onCancelText}
      okText={onOkText}
      className={styles.confirmationModal}
      closeIcon={false}
      centered
      okButtonProps={{
        danger: isDanger,
        loading,
        disabled,
      }}
      cancelButtonProps={{
        disabled,
      }}
    >
      <div className={styles.confirmationModal_content}>
        <div className={styles.confirmationModal_content_icon}>
          <ExclamationCircleOutlined />
        </div>
        <div>{getModalContent()}</div>
      </div>
    </Modal>
  );
};
export default ConfirmationModal;
